import { ActionTree } from 'vuex';
import Axios, { AxiosResponse } from 'axios';
import { ApplicationsState, ConversationMessage, MessageToSend } from './types';
import { readMeta } from '@/lib/page';
import { refreshedJwt } from '@/lib/jwt';
import { getNextApplicationIdAfterRemoval } from './listNavigation';

type ApplicationStatus = 'RECEIVED' | 'INTERESTED' | 'NOT_A_FIT';

interface MoveApplicationPayload {
  applicationId: string;
  fromStatus: ApplicationStatus;
  toStatus: ApplicationStatus;
}

const statusTotalConfig = {
  RECEIVED: {
    getter: 'receivedTotal',
    mutation: 'setReceivedTotal',
  },
  INTERESTED: {
    getter: 'interestedTotal',
    mutation: 'setInterestedTotal',
  },
  NOT_A_FIT: {
    getter: 'notAFitTotal',
    mutation: 'setNotAFitTotal',
  },
};

const actions: ActionTree<ApplicationsState, any> = {
  async postConversationData(_, { conversationUUID, messageBody }: ConversationMessage): Promise<void | AxiosResponse<any>> {
    const scPublicApiUrl = readMeta('sc_public_api_url');
    const token = await refreshedJwt();
    if (!token) throw new Error('Cannot message without being logged in');

    const messageToSend: MessageToSend = {
      'com.sittercity.messages:Message': {
        body: messageBody,
      },
    };

    return Axios.post(`${scPublicApiUrl}/conversations/${conversationUUID}/messages`, messageToSend, {
      headers: {
        Accept: 'application/json; version=2',
        'Content-Type': 'application/json',
        authorization: `Bearer ${token}`,
      },
    }).catch((err) => {
      // @ts-ignore

      console.error(err);
    });
  },

  moveApplication({ commit, getters }, { applicationId, fromStatus, toStatus }: MoveApplicationPayload) {
    const nextApplicationId = getNextApplicationIdAfterRemoval(getters.job.applications.edges, applicationId);
    const fromConfig = statusTotalConfig[fromStatus];
    const toConfig = statusTotalConfig[toStatus];

    commit('setRemoveApplicantFromList', applicationId);
    commit(fromConfig.mutation, { applications: { totalCount: Math.max(0, getters[fromConfig.getter] - 1) } });
    commit(toConfig.mutation, { applications: { totalCount: getters[toConfig.getter] + 1 } });

    return nextApplicationId;
  },

  showMessageSentNotification({ commit }, message: string): void {
    commit('setMessageSentNotification', true);
    commit('setToastNotificationMessage', message);
  },

  hideMessageSentNotification({ commit }): void {
    commit('setMessageSentNotification', false);
  },

  showApplicationLoading({ commit }, changeTo: boolean): void {
    commit('setShowApplicationLoading', changeTo);
  },
};

export default actions;
